import script from "./HighsLowsHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./HighsLowsHeader.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__